import {
  FormField,
  type FormFieldProps,
  TextArea,
  type TextAreaProps,
} from '@moia-dev/pace-web'
import { useId } from 'react'

export type TextareaProps = Pick<
  FormFieldProps,
  'label' | 'caption' | 'validation'
> &
  TextAreaProps

export const Textarea = ({
  label,
  name,
  caption,
  id: maybeId,
  validation,
  maxLength,
  value,
  required,
  onChange,
  children,
  ...props
}: TextareaProps) => {
  const generatedId = useId()
  const id = maybeId ? maybeId : generatedId
  return (
    <FormField
      required={required}
      value={maxLength && typeof value === 'string' ? value : undefined}
      maxLength={maxLength}
      caption={caption}
      label={label}
      htmlFor={id}
      validation={validation}
    >
      <TextArea
        id={id}
        name={name}
        {...{ ...props, required, onChange, value, maxLength }}
      />
    </FormField>
  )
}
